import { paymentSuccessGoBack } from './paymentSuccessGoBack';

export const PAYMENT_STATUS_EVENT = 'paymentStatus';

export type PaymentStatusValue = 'success' | 'failure';

export type PaymentStatusMessageParams = {
  status: PaymentStatusValue;
  is_wallet?: string | boolean;
  payment_return_to?: string;
  error_message?: string;
  [key: string]: unknown;
};

export const createPaymentStatusMessage = (
  params: PaymentStatusMessageParams
) => ({
  eventName: PAYMENT_STATUS_EVENT,
  params
});

type NotifyPaymentStatusOptions = {
  legacyMessage?: string;
  closeWindow?: boolean;
};

export const notifyPaymentStatus = (
  params: PaymentStatusMessageParams,
  options: NotifyPaymentStatusOptions = {}
) => {
  const message = createPaymentStatusMessage(params);
  const paymentReturnTo = params.payment_return_to ?? '';
  const isWallet = params.is_wallet === true || params.is_wallet === 'true';
  const { legacyMessage, closeWindow = true } = options;

  if (window.ReactNativeWebView) {
    try {
      if (legacyMessage) {
        window.ReactNativeWebView.postMessage(legacyMessage);
      }

      if (isWallet) {
        window.localStorage.setItem('paymentStatus', JSON.stringify(message));
        paymentSuccessGoBack(paymentReturnTo);
      } else {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      }
    } catch (error) {
      console.error(error);
    }
    return;
  }

  if (window.opener) {
    if (legacyMessage) {
      window.opener.postMessage(legacyMessage, '*');
    }
    window.opener.postMessage(JSON.stringify(message), '*');

    if (closeWindow) {
      window.close();
    }
    return;
  }

  if (paymentReturnTo) {
    window.location.href = paymentReturnTo;
  } else {
    window.history.go(-2);
  }
};

const isPaymentStatusMessage = (
  parsed: unknown
): parsed is { eventName: string; params: PaymentStatusMessageParams } =>
  !!(
    parsed &&
    typeof parsed === 'object' &&
    'eventName' in parsed &&
    parsed.eventName === PAYMENT_STATUS_EVENT &&
    'params' in parsed &&
    parsed.params &&
    typeof parsed.params === 'object' &&
    'status' in parsed.params
  );

export const parsePaymentStatusMessage = (
  data: unknown
): PaymentStatusMessageParams | null => {
  if (data === 'paymentFailure') {
    return { status: 'failure' };
  }

  if (data === 'paymentFinished') {
    return { status: 'success' };
  }

  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;

    if (isPaymentStatusMessage(parsed)) {
      return parsed.params;
    }
  } catch {
    return null;
  }

  return null;
};

export const parsePaymentReturnMessage = (
  data: unknown
): PaymentStatusMessageParams | null => {
  if (data === 'paymentFailure') {
    return { status: 'failure' };
  }

  if (data === 'paymentFinished') {
    return { status: 'success' };
  }

  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;

    if (isPaymentStatusMessage(parsed)) {
      return parsed.params;
    }
  } catch {
    return null;
  }

  return null;
};
